module.exports = __webpack_public_path__ + "media/application/images/business-modelling/welcome@2x-acd71dba49102073d8d75ff833fc3b4d.jpg";